module.exports = __webpack_public_path__ + "img/img5.a1233a72.jpg";